export const formatListContentCopyText = listProps =>
  listProps.map(item => `${item.label}: ${item.text}`).join('\n');
